import { useContext, useEffect, useState } from "react";
import { RootContext } from "../../../../stores";
import { AppError } from "../../../../stores/models/errors/AppError";
import { IOrganizationSignUpFlowValues } from "../_interfaces/IOrganizationSignUpFlowValues";
import { OrganizationSignUpTriageStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";

export function useOrganizationSignUpTriageController(
    values: OrganizationSignUpTriageStepValues,
    allValues: IOrganizationSignUpFlowValues,
    update: (patch: Partial<OrganizationSignUpTriageStepValues>) => void,
    onSuccess: (override?: Partial<OrganizationSignUpTriageStepValues>) => void
) {
    const rootStore = useContext(RootContext);
    const userStore = rootStore.userStore;
    const user = userStore.user;

    const [error, setError] = useState<string>();
    const [isSubmitting, setSubmitting] = useState(false);
    const [validationRun, setValidationRun] = useState(false);

    // Set initial flow values
    useEffect(() => {
        const patch: IOrganizationSignUpFlowValues = {
            isAuthenticated: userStore.isAuthenticated,
            hasExistingOrganizationProfile: user.hasOrganizationProfile,
            hasAccount: userStore.isAuthenticated,
            currentUserEmail: userStore.user.email,
            currentUserName: userStore.user.name || "",
            username: "",
            password: "",
            confirmedPassword: "",
            passwordsMatch: false,
            termsOfServiceAccepted: false,
            organizationName: "",
            ein: "",
            signUpCode: "",
            mission: "",
            description: "",
            website: "",
            isForProfit: false,
            backClicked: false,
            loading: false
        };
        update(patch);
        submit(patch);
    }, [userStore.isAuthenticated, user.hasOrganizationProfile, user.name, user.email]);

    const submit = async (override?: Partial<OrganizationSignUpTriageStepValues>) => {
        setSubmitting(true);
        setError(undefined);
        setValidationRun(true);

        try {
            onSuccess(override);
        } catch (err) {
            if (err instanceof AppError) {
                switch (err.code) {
                    default:
                        setError(err.message);
                }
            } else {
                setError("An unknown error occurred.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return {
        values,
        onChange: update,
        onSubmit: submit,
        isSubmitting,
        error,
    };
}
